<template>
    <div class="search">
        <div class="form-wrapper" v-show="showForm && !searchActive">
            <h2 class="page-title">Search Recommendations</h2>
            <form id="form" class="form" method="GET" action="/" @submit.prevent="changeCriteriaAndSearch(api)">
                <div class="form__wrapper">
                    <div class="form__field" v-for="field in schema" :key="field.Key">
                        <label :for="field.Key" class="form__label">{{ field.Name }}</label>
                        <component :is="field.Type"
                                   v-model="formData[field.Key]"
                                   :field="field"
                                   :disabled="field.Disabled"
                                   >
                        </component>
                    </div>
                </div>
                <button type="submit" class="form__submit-btn">
                    Search
                </button>
            </form>
        </div>
        <div class="page-header" v-show="results.length > 0">
            <h2 class="page-title">Search results</h2>
            <div class="page-options">

                <button class="page-options__print-btn" v-on:click="seeAll()" title="See all" aria-label="See all">See all</button>
                <button class="page-options__print-btn" v-on:click="expandAll()" title="Expand all" aria-label="Expand all">Expand all</button>
                <button class="page-options__print-btn" v-on:click="closeAll()" title="Close all" aria-label="Close all">Close all</button>
                <button href="" v-on:click="print()" class="page-options__print-btn" title="Print" aria-label="Print">Print<i class="icon-print"></i></button>
                <export-dropdown :formData="formData" />
            </div>
        </div>
        <div class="search__criterias">
            <criteria-list v-show="showCriterias" :filters="criterias" :showForm="toggleForm" :schema="schema"/>
        </div>
        <div class="search__sort" v-show="results.length > 0">
            <sort-dropdown v-model="formData['sortBy']" :submit="sendForm" />
        </div>
        <div class="search__searching" v-show="searchActive">
            <div class="loader"></div>
            Searching for results
        </div>
        <div class="search__no-results" v-show="!searchActive && searchFinished && results.length == 0">
            No results have been found
        </div>
        <search-results :results="results" :form-data="formData" v-show="results.length > 0 && !searchActive" />
        <pagination v-show="results.length > 0 && !searchActive"  :pages="totalPages" :current="currentPage" v-model="formData['page']" :submit="sendForm"  />
        <export-loader :text="loaderText" v-show="showLoader"/>
    </div>
</template>

<script>
import MultiSelectWrapper from "./custom-inputs/MultiSelectWrapper";
import NumberInput from "./custom-inputs/NumberInput";
import TextboxInput from "./custom-inputs/TextboxInput";
import CheckboxInput from "./custom-inputs/CheckboxInput";
import DateInput from "./custom-inputs/DateInput";
import SearchResults from "./SearchResults";
import SortDropdown from "./partials/SortDropdown";
import CriteriaList from "./partials/CriteriaList";
import ExportDropdown from "./partials/ExportDropdown";
import Pagination from "./partials/Pagination";
import ExportLoader from "./partials/ExportLoader";

import axios from 'axios';
import queryString from 'query-string';
import isEmpty from 'lodash/isEmpty';

import moment from 'moment';
import SearchApi from '../api/searchApi.js'
import FilesExportApi from '../api/filesExportApi.js'
import ContentApi from '../api/contentApi.js'

import ProjectBeneficiariesService from '../services/projectBeneficiariesService.js'

const searchAPI = "/umbraco/surface/api/search";
const advancedSearchApi = "/umbraco/surface/api/searchadvanced";

export default {
    name: "Form",
    components: {
        MultiSelectWrapper,
        NumberInput,
        TextboxInput,
        CheckboxInput,
        SearchResults,
        SortDropdown,
        CriteriaList,
        ExportDropdown,
        Pagination,
        ExportLoader,
        DateInput
    },
    data() {
        return {
            schema: [],
            results: [],
            formData: {},
            criterias: {},
            query: queryString.parse(location.search),
            showCriterias: false,
            showForm: true,
            searchActive: false,
            searchFinished: false,
            api: advancedSearchApi,
            currentPage: 1,
            totalPages: 0,
            loaderText: 'Loading...',
            showLoader: false
        };
    },
    created() {
        let vm = this;

        if (!isEmpty(this.query) && !redirectedFromOtherBeneficiaries()) {
            this.formData = this.query;
            this.showForm = false;

            if (this.query.query) {
                this.formData['page'] = 1
                this.sendForm(searchAPI);
            } else {
                this.sendForm(advancedSearchApi);
            }
        }

        function redirectedFromOtherBeneficiaries(){
           return window.location.href.slice(window.location.href.indexOf('?') + 1) == "onlyOtherBeneficiaries=true&page=1";
        }

        Promise.all([axios.get("/umbraco/surface/api/getdropdownvalues"), ContentApi.getOtherBeneficiaries()])
            .then((values) => {
                
                var dropDowns = values[0].data;
                var otherBeneficiaries = values[1].data;

                this.schema = dropDowns;

                ProjectBeneficiariesService.handleBeneficiaries(this.schema, otherBeneficiaries, this.formData);

            }).catch(error => {
                console.log(error);
            })

        window.onafterprint = function(){
            vm.results = vm.results.filter(rec => {
                return !rec.printing
            })
        }
    },
    
    watch :{
        criterias: {
            handler: function () {
                for (var prop in this.criterias) {
                    if (!this.criterias[prop] || this.criterias[prop].length === 0) {
                        this.$delete(this.criterias, prop);
                    }
                }
            },
            deep: true
        },
    },
    methods: {
        changeCriteriaAndSearch(api) {
            this.$delete(this.criterias, 'page');
            this.$delete(this.criterias, 'query');
            this.formData['page'] = 1;
            this.sendForm(api);
        },
        seeAll() {
            this.closeAll();
            this.formData['page'] = undefined;
            this.$delete(this.criterias, 'page');
            this.sendForm();
        },
        expandAll() {
            var searchResults = _.filter(this.$children, e => { return e.$vnode.tag.endsWith("SearchResults") })[0];
            _.each(searchResults.$children, item => item.expand = true);
        },
        closeAll() {
            var searchResults = _.filter(this.$children, e => { return e.$vnode.tag.endsWith("SearchResults") })[0];
            for (var i = 0; i < searchResults.$children.length; i++) {
                var item = searchResults.$children[i];
                item.expand = false;
            }
        },
        sendForm(endpoint) {
            if (!endpoint) {
                if (this.query.query) {
                    endpoint = searchAPI;
                } else {
                    endpoint = advancedSearchApi;
                }
            }

            history.pushState(null, null, '?' + queryString.stringify(this.formData));

            this.searchActive = true;

            if (!isEmpty(this.formData)) {
                this.criterias = this.formData;
                this.showCriterias = true;
            }

            axios.post( endpoint, this.formData).then(response => {
                this.results = response.data.Data;
                this.totalPages = response.data.TotalPages;
                this.currentPage = response.data.CurrentPage;
            }).catch(function (error) {
                console.log(error);
            }).then(() => {
                this.showForm = false;
                this.searchActive = false;
                this.searchFinished = true;
            });
        },
        toggleForm() {
            this.showForm = !this.showForm;
        },
        removePrintElements() {
            this.results = this.results.filter(element => {
                return !element.printing;
            })
        },
        print() {
            this.showLoader = true;

            SearchApi.searchForPrinting(this.formData).then(response => {

                this.results = this.results.filter(element => {
                    return !element.printing;
                });

                response.data.Data.forEach(element => {
                    element.printing = true;
                });

                this.results = this.results.concat(response.data.Data);
                
                this.$nextTick(this.startPrinting);
            }).catch(function (error) {
                console.log(error);
            }).then(() => {
                this.showLoader = false;
            });  
        },
        startPrinting() {
            window.print(); 
        }
    }
};
</script>

<style lang="scss" scoped>
@import "src/scss/variables";

    .form {
        width: 100%;
        padding: 30px 30px;
        border-width: 2px;
        border-style: solid;
        border-radius: 3px;
        position: relative;
        margin: 20px 0;

        @media (max-width: 767px) {
            padding: 20px;
        }

        &__wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    @media (max-width: 767px) {
      flex-direction: column;
    }
  }

  &__column {
    flex: 0 0 50%;
    padding-right: 20px;
    box-sizing: border-box;

    &--right {
      padding-right: 0;
      padding-left: 20px;
    }
  }

  &__field {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex: 0 0 49%;
    width: 49%;
    margin-bottom: 15px;

    &.input {
      width: 250px;
      @media (max-width: 767px) {
        width: 100%;
      }
    }

    @media (max-width: 767px) {
      flex-direction: column;
      width: 100%;
    }
  }

  &__label {
    min-height: 40px;
    display: flex;
    align-items: center;
    text-align: left;

    @media (max-width: 767px) {
      margin-bottom: 10px;
      min-height: 0;
    }
  }

    &__submit-btn {
        width: 100%;
        height: 40px;
        border-width: 2px;
        border-style: solid;       
        border-radius: 5px;
        font-family: $main-font;
        text-transform: uppercase;       
        transition: all 0.3s;
        outline: none;
        margin-top: 30px;

    .icon-search {
      position: relative;
      transform: rotate(45deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Form.vue